module.exports = __webpack_public_path__ + "static/img/fa331d14.c10.6f0a7da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/fa331d14.c10.jpg
// module id = 9erF
// module chunks = 2